import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact.ts';
import { RuleType } from '../../IRule.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';
import { MAX_ATTACHMENT_SIZE } from './maxAttachmentSize.ts';

const fieldName = `rules.${RuleType.MaxDimension}`;

export interface IMaxDimensionRuleComponentProps {}

export function MaxDimensionRuleComponent(
  props: IMaxDimensionRuleComponentProps,
) {
  return (
    <FormItem
      name={`${fieldName}.value`}
      label="Dimensione Massima"
      help="Se non impostata, la dimensione massima per l'upload è di 100MB"
    >
      <$SpaceCompact block size="large">
        <NumberInput
          addonBefore="MB"
          name={`${fieldName}.value`}
          allowClear
          defaultValue={MAX_ATTACHMENT_SIZE}
        />
        <CustomValidationRuleMessage name={`${fieldName}.customMessage`} />
      </$SpaceCompact>
    </FormItem>
  );
}
